import { Filter } from '@components/atoms';
import { ActionContainer, ActionContainerVariant, Button, ButtonSize, ButtonVariant } from '@components/molecules';

type BackButtonProps = React.PropsWithChildren<{
	onAction?: () => void;
	isActive: boolean;
	disabled?: boolean;
}>;

const FilterButton: React.FC<BackButtonProps> = ({ onAction, isActive, disabled }) => {
	return (
		<ActionContainer variant={isActive ? ActionContainerVariant.ACTIVE : ActionContainerVariant.INACTIVE}>
			<Button
				variant={ButtonVariant.ICON}
				size={ButtonSize.XS}
				onClick={onAction}
				className="h-auto p-[8px]"
				disabled={disabled}
				data-testid="filter-button"
			>
				<Filter className={isActive ? 'text-primary' : 'text-secondary'} />
			</Button>
		</ActionContainer>
	);
};

export { FilterButton };
